// extracted by mini-css-extract-plugin
export default {"table":"table_table__PJj7e","typogrpahy_header":"table_typogrpahy_header__PphRM"};